import { Pipe, PipeTransform } from '@angular/core';
import { EventGuestDetails } from '../../../shared/models/events/guests/event-guest-details.model';

@Pipe({
  name: 'guestGroupFullname'
})
export class GuestGroupFullnamePipe implements PipeTransform {

  transform(value: EventGuestDetails, withPriority: boolean = false): any {
    var ret = "" 
    if(value != null && value.group1Name != null) {
      ret += (withPriority && value.group1Position != null ? value.group1Position + ". ":"") + value.group1Name 
        + (value.group2Name ? " > " + (withPriority && value.group2Position != null ? value.group2Position + ". ":"") +  value.group2Name : "")
        + (value.group3Name ? " > " + (withPriority && value.group3Position != null ? value.group3Position + ". ":"") + value.group3Name : "")
        + (value.group4Name ? " > " + (withPriority && value.group4Position != null ? value.group4Position + ". ":"") + value.group4Name : "")
        + (value.group5Name ? " > " + (withPriority && value.group5Position != null ? value.group5Position + ". ":"") + value.group5Name : "")
        + (value.group6Name ? " > " + (withPriority && value.group6Position != null ? value.group6Position + ". ":"") + value.group6Name : "");
    }
    
    return ret;
  }

}
